import { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { Button } from "@mui/material";
import { Grid, FormControl, MenuItem, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import api from "../../../config/api";
import { Fragment } from "react";
import "./CreateProductForm.css";
import { useDispatch } from "react-redux";
import { createProduct } from "../../../Redux/Customers/Product/Action";

const initialSizes = [
  { name: "S", quantity: 0 },
  { name: "M", quantity: 0 },
  { name: "L", quantity: 0 },
];

const colors = [
  "White",
  "Black",
  "Red",
  "Maroon",
  "Beige",
  "Pink",
  "Green",
  "Yellow",
  "Blue",
  "Brown",
  "Purple",
  "Gray",
];

const CreateProductForm = () => {
  const [productData, setProductData] = useState({
    images: [], // Store multiple image files here
    brand: "",
    title: "",
    color: "",
    discountedPrice: "",
    price: "",
    discountPersent: "",
    size: initialSizes,
    quantity: "",
    topLavelCategory: "",
    secondLavelCategory: "",
    thirdLavelCategory: "",
    description: "",
  });
  const [topLavelCategory, setTopLavelCategory] = useState([]);
  const [secondLavelCategory, setSecondLavelCategory] = useState([]);
  const [thirdCategory, setThirdLavelCategory] = useState([]);

  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");

  useEffect(() => {
    const getCategories = async () => {
      try {
        const categories = await api.get(`/api/categories`);
        const topcat = categories.data
          .filter((topcat) => topcat.level === 1)
          .map((name) => {
            return name.name;
          });
        const seccat = categories.data
          .filter((topcat) => topcat.level === 2)
          .map((name) => {
            return name.name;
          });
        const thirdcat = categories.data
          .filter((topcat) => topcat.level === 3)
          .map((name) => {
            return name.name;
          });

        setTopLavelCategory(topcat);
        setSecondLavelCategory(seccat);
        setThirdLavelCategory(thirdcat);
      } catch (error) {
        if (error.status == 400) {
          console.log(error.response.data.message);
        }
      }
    };
    getCategories();
  }, []);

  // Handle input change for text fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle size change for each size field
  const handleSizeChange = (e, index) => {
    let { name, value } = e.target;
    if (name === "size_quantity") {
      name = "quantity"; // Rename the field to quantity for size
    }

    const sizes = [...productData.size];
    sizes[index][name] = value;
    setProductData((prevState) => ({
      ...prevState,
      size: sizes,
    }));
  };

  // Handle adding a new size field
  const handleAddSize = () => {
    const sizes = [...productData.size];
    sizes.push({ name: "", quantity: "" });
    setProductData((prevState) => ({
      ...prevState,
      size: sizes,
    }));
  };

  // Handle file change (image upload)
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files); // Convert FileList to array
    setProductData((prevState) => ({
      ...prevState,
      images: files, // Store the selected files in the images array
    }));
    console.log("files frontend", files);
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Prepare FormData for API submission (include both text data and files)
    const formData = new FormData();

    // Append images to formData
    productData.images.forEach((image) => {
      formData.append("images", image);
    });

    // Append other fields to formData
    for (const key in productData) {
      if (key === "size") {
        // For sizes, append them as JSON strings (array of objects)
        productData.size.forEach((size) => {
          formData.append("sizes[]", JSON.stringify(size));
        });
      } else if (key !== "images") {
        formData.append(key, productData[key]);
      }
    }

    // Dispatch action to create product with the form data
    dispatch(createProduct({ data: formData, jwt }));
    // alert("Product added successfully");
    // window.location.href = "/admin/product/create";

    // Log the form data for debugging
    console.log("Form data submitted:", formData);
  };

  return (
    <Fragment className="createProductContainer">
      <Typography
        variant="h3"
        sx={{ textAlign: "center" }}
        className="py-10 text-center"
      >
        Add New Product
      </Typography>
      <form
        onSubmit={handleSubmit}
        className="createProductContainer min-h-screen"
        encType="multipart/form-data"
        method="post"
      >
        <Grid container spacing={2}>
          {/* Image Upload Section */}
          <Grid item xs={12}>
            <input
              type="file"
              multiple // Allow multiple files
              accept="image/*" // Only accept image files
              name="images"
              onChange={handleImageChange}
            />
            {productData.images.length > 0 && (
              <div>
                <h4>Selected Images:</h4>
                <ul>
                  {productData.images.map((file, index) => (
                    <li key={index}>{file.name}</li>
                  ))}
                </ul>
              </div>
            )}
          </Grid>

          {/* Other form fields */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Brand"
              name="brand"
              value={productData.brand}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title"
              name="title"
              value={productData.title}
              onChange={handleChange}
            />
          </Grid>

          {/* <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Color"
              name="color"
              value={productData.color}
              onChange={handleChange}
            />
          </Grid> */}

          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Color"
              name="color"
              value={productData.color}
              onChange={handleChange}
            >
              {colors.map((color) => (
                <MenuItem key={color} value={color}>
                  {color}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Quantity"
              name="quantity"
              value={productData.quantity}
              onChange={handleChange}
              type="number"
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Price"
              name="price"
              value={productData.price}
              onChange={handleChange}
              type="number"
               inputProps={{ min: 1 }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Discounted Price"
              name="discountedPrice"
              value={productData.discountedPrice}
              onChange={handleChange}
              type="number"
                 inputProps={{ min: 1 }}
            />
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Discount Percentage"
              name="discountPersent"
              value={(Math.round(100-(productData.discountedPrice/productData.price)*100))}
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <FormControl fullWidth>
              <Autocomplete
                freeSolo
                options={topLavelCategory}
                value={productData.topLavelCategory || ""}
                onChange={(event, newValue) => {
                  handleChange({
                    target: { name: "topLavelCategory", value: newValue },
                  });
                }}
                onInputChange={(event, newInputValue) => {
                  handleChange({
                    target: { name: "topLavelCategory", value: newInputValue },
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Top Level Category" />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={4}>
            <FormControl fullWidth>
              <Autocomplete
                freeSolo
                options={secondLavelCategory}
                value={productData.secondLavelCategory || ""}
                onChange={(event, newValue) => {
                  handleChange({
                    target: { name: "secondLavelCategory", value: newValue },
                  });
                }}
                onInputChange={(event, newInputValue) => {
                  handleChange({
                    target: {
                      name: "secondLavelCategory",
                      value: newInputValue,
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Second Level Category" />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={4}>
            <FormControl fullWidth>
              <Autocomplete
                freeSolo
                options={thirdCategory}
                value={productData.thirdLavelCategory || ""}
                onChange={(event, newValue) => {
                  handleChange({
                    target: { name: "thirdLavelCategory", value: newValue },
                  });
                }}
                onInputChange={(event, newInputValue) => {
                  handleChange({
                    target: {
                      name: "thirdLavelCategory",
                      value: newInputValue,
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Third Level Category" />
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Description"
              name="description"
              value={productData.description}
              onChange={handleChange}
              multiline
              rows={3}
            />
          </Grid>

          {/* Size selection */}
          {productData.size.map((size, index) => (
            <Grid container item spacing={3} key={index}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Size Name"
                  name="name"
                  value={size.name}
                  onChange={(event) => handleSizeChange(event, index)}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Quantity"
                  name="size_quantity"
                  type="number"
                  value={size.quantity}
                  onChange={(event) => handleSizeChange(event, index)}
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
          ))}

          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{ p: 1.8 }}
              size="large"
              type="submit"
              // onClick={() => {
              //   alert("Product added successfully");
              //   window.location.href = "/admin/product/create";
              // }}
            >
              Add New Product
            </Button>
          </Grid>
        </Grid>
      </form>
    </Fragment>
  );
};

export default CreateProductForm;
